<div class="dash-card continue-card">
  <div class="continue-card__head">
    <div class="dash-card__title mb-0">{{ 'dashboard.ContinueLearning' | translate }}</div>
    <a routerLink="/courses/my" class="continue-card__all">{{ 'dashboard.AllMyCourses' | translate }}</a>
  </div>

  <div *ngIf="loading" class="continue-card__loading"><span class="spinner-border spinner-border-sm me-2"></span>{{ 'app.Loading' | translate }}</div>

  <div *ngIf="!loading && items.length === 0" class="continue-card__empty">
    <i class="bi bi-mortarboard"></i>
    <p class="dash-empty mb-2">{{ (failed ? 'dashboard.CoursesUnavailable' : 'dashboard.NoCoursesInProgress') | translate }}</p>
    <a *ngIf="!failed" routerLink="/courses/my" class="btn btn-sm btn-outline-primary">{{ 'dashboard.BrowseCourses' | translate }}</a>
  </div>

  <ul class="continue-list" *ngIf="!loading && items.length">
    <li *ngFor="let item of items">
      <a class="continue-item" [routerLink]="link(item)">
        <span class="continue-item__thumb" aria-hidden="true">{{ initial(item) }}</span>
        <span class="continue-item__body">
          <span class="continue-item__title" dir="auto">{{ item.title }}</span>
          <span class="continue-item__meta" dir="auto">
            <ng-container *ngIf="item.status === Status.Completed; else inProgress">
              <i class="bi bi-patch-check-fill text-success me-1"></i>{{ 'dashboard.CourseCompleted' | translate }}
            </ng-container>
            <ng-template #inProgress>
              <ng-container *ngIf="item.resumeLessonTitle; else lessonsDone">{{ 'dashboard.NextLesson' | translate: { title: item.resumeLessonTitle } }}</ng-container>
              <ng-template #lessonsDone>{{ 'dashboard.LessonsDone' | translate: { done: item.completedLessons, total: item.totalLessons } }}</ng-template>
            </ng-template>
          </span>
          <span class="continue-item__progress">
            <span class="dash-bar__track"><span [style.width.%]="item.progressPercent"></span></span>
            <span class="continue-item__pct">{{ round(item.progressPercent) }}%</span>
          </span>
        </span>
        <i class="bi bi-chevron-right flip-rtl continue-item__go"></i>
      </a>
    </li>
  </ul>
</div>
